import useGet from "api/useGet";
import { EditerBox } from "component/app/items";
import { FixedBox_btnItem, TermsPopupSubTitle } from "component/app/subItem";
import { FixedSection } from "component/basic";
import { CustomPopup } from "component/basic/popup";
import { FilterSection } from "component/product/Filter";
import { isMobile, setDateTime } from "js/function";
import { RentPopupContents } from "pages/popup/Popup";
import {useEffect, useRef, useState} from "react";
import { useNavigate } from "react-router-dom";

function BoardTitleBox(data){
    return (
        <div className={`boardTitleBox ${data.addClass||""}`}>
            <h2 className={`boardTitle`} dangerouslySetInnerHTML={{__html:data.title}}/>
            {data.subTitle ? <h3 className={`boardSubTitle`} dangerouslySetInnerHTML={{__html:data.subTitle}}/> : ""}
        </div> 
    );
}

function BoardLabelItem(data){
    return (
        <p className={`boardLabelItem ${data.status == 0 ? "bColor" : ""}`}>{data.status == 0 ? "진행중" : data.status == 1 ? "마감됨" : "-"}</p>
    );
}

function BoardListBox(data){
    return (
        <div className={`boardListBox ${data.addClass||""}`}>
            {data.children}
        </div> 
    );
}

function BoardListItem(data){
    const navigate = useNavigate();

    return (
        <button type="button" className={`boardListItem ${data.addClass||""} ${data.type === "notice" ? "noticeListItem" : ""}`} onClick={()=>{navigate(`/${data.type}/detail/${data?.data?.id}`)}}>
            <div className="boardListItem_titleArea">
                {data.type === "event" ? 
                    <div className={`boardListItem_titleImgBox backgroundImg`} aria-label={data?.data?.image_alt ?? (data?.type + "-" + (data?.data?.id))} style={{backgroundImage:`url('${data?.data?.image_url}')`}}>
                        <BoardLabelItem
                            status={data?.data?.status}
                        />
                    </div>
                :""}
                <BoardTitleBox
                    title={data?.data?.title}
                    subTitle={
                        data.type === "event" && (data?.data?.start_date || data?.data?.end_date) ? 
                        `${data?.data?.start_date ? setDateTime(data?.data?.start_date,"yymmdd","hymd") : ""}${data?.data?.start_date && data?.data?.end_date ? " ~ " : ""}${data?.data?.end_date ? setDateTime(data?.data?.end_date,"yymmdd","hymd") : ""}`
                        : data?.data?.created_at ? setDateTime(data?.data?.created_at,"yymmddhhtt","hymd") : null
                    }
                />
            </div>
            <img src="/assets/images/icon/mypage_move.svg"/>
        </button>
    );
}

function BoardDetailPage(data){
    return (
        <div className={`boardDetailPage ${data.addClass||""}`}>
            {data.children}
        </div> 
    );
}

function BoardDetailSection(data){
    const imgRef = useRef(null);

    function notImg(){
        imgRef?.current?.classList?.add("notImg");
    }

    return (
        <div className={`boardDetailSection ${data.addClass||""}`}>
            <div className="boardDetail_titleArea">
                {data.type === "event" ? 
                    <BoardLabelItem
                        status={data?.data?.status}
                    />
                :""}
                <BoardTitleBox
                    title={data?.data?.title}
                    subTitle={
                        data.type === "event" && (data?.data?.start_date || data?.data?.end_date) ? 
                        `${data?.data?.start_date ? setDateTime(data?.data?.start_date,"yymmdd","hymd") : ""}${data?.data?.start_date && data?.data?.end_date ? " ~ " : ""}${data?.data?.end_date ? setDateTime(data?.data?.end_date,"yymmdd","hymd") : ""}`
                        : data?.data?.created_at ? setDateTime(data?.data?.created_at,"yymmddhhtt","hymd") : null
                    }
                />
            </div>
            <div className="boardDetail_contentsArea">
                {data.type === "event" && data?.data?.image_url ? 
                    <img src={data?.data?.image_url} alt={data?.data?.image_alt ?? (data?.type + "-" + (data?.data?.id))} ref={imgRef} onError={(e)=>{notImg()}}/>
                :""}
                <div className="boardDetail_contentsBox">
                    <EditerBox addClass="" data={data?.data?.contents}/>
                </div>
            </div>
        </div> 
    );
}

function CsControll(data){
    const navigate = useNavigate();

    const shuttleApi = useGet({
        url:`/shuttle`,
        loginType:"login"
    });
    const shuttleData = shuttleApi?.data;
    
    const reservationApi = useGet({
        url:`/reservation/rule`,
        loginType:"login"
    });
    const reservationData = reservationApi?.data;

    const [shuttlePopup,setShuttlePopup] =  useState(null);
    const [reservationPopup,setReservationPopup] =  useState(null);
    const [rentPopup,setRentPopup] =  useState(null);

    const [addrPosition,setAddrPosition] =  useState(null);

    useEffect(()=>{
        if (data.pram === "shuttle") {
            setShuttlePopup({
                addClass:"",
                title:"셔틀버스 이용 안내",
                subTitle:null,
                closeType:true,
                closeFunc:(e) => {setShuttlePopup(null)},
                closePcOn:true
            });
        } else if (data.pram === "reservation") {
            setReservationPopup({
                addClass:"",
                title:"예약 취소/변경 규정 안내",
                subTitle:null,
                closeType:true,
                closeFunc:(e) => {setReservationPopup(null)},
                closePcOn:true
            });
        }
    }, [data])

    return (
        <FixedSection
            pageBox="pageSizing"
            boxAddClass={`fixedsection_min ${data.boxAddClass||""}`}
            addClass="fixedArea_min"
            contentsBox="fixedPage"
            headerChk={true}
            footerChk={true}
            minSize={961}
            title="고객센터"
            titleAddClass={"pcItemT"}
        >
            <FilterSection addClass="flexBtnItemM">
                <FixedBox_btnItem
                    text={"이벤트"}
                    icon={"/assets/images/icon/event_icon.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/event")
                    }}
                />
                <FixedBox_btnItem
                    text={"공지사항"}
                    icon={"/assets/images/icon/notice_icon.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/notice")
                    }}
                />
                {shuttleData ? 
                    <FixedBox_btnItem
                        text={"셔틀버스 이용 안내"}
                        icon={"/assets/images/icon/reservation_icon_0.svg"}
                        addClass=""
                        func={()=>{
                            setShuttlePopup({
                                addClass:"",
                                title:"셔틀버스 이용 안내",
                                subTitle:null,
                                closeType:true,
                                closeFunc:(e) => {setShuttlePopup(null)},
                                closePcOn:true
                            });
                        }}
                    />
                :""}
                {addrPosition ? 
                    <FixedBox_btnItem
                        text={"렌터카 대여/반납지 안내"}
                        icon={"/assets/images/icon/reservation_icon_1.svg"}
                        addClass=""
                        func={()=>{
                            setRentPopup({
                                addClass:"",
                                title:"렌터카 대여/반납지 안내",
                                subTitle:null,
                                closeType:true,
                                closeFunc:(e) => {setRentPopup(null)},
                                closePcOn:true
                            });
                        }}
                    />
                :""}
                {reservationData ? 
                    <FixedBox_btnItem
                        text={"예약 취소/변경 규정 안내"}
                        icon={"/assets/images/icon/reservation_icon_2.svg"}
                        addClass=""
                        func={()=>{
                            setReservationPopup({
                                addClass:"",
                                title:"예약 취소/변경 규정 안내",
                                subTitle:null,
                                closeType:true,
                                closeFunc:(e) => {setReservationPopup(null)},
                                closePcOn:true
                            });
                        }}
                    />
                :""}
            </FilterSection>
            <CustomPopup data={shuttlePopup} basicPB={true} mSize={true}>
                <EditerBox addClass="" data={shuttleData?.contents}/>
            </CustomPopup>

            <CustomPopup data={reservationPopup} basicPB={true} mSize={true}>
                <TermsPopupSubTitle title={"예약 취소 규정"}/>
                <EditerBox addClass="minSize" data={reservationData?.cancel_information}/>
                <TermsPopupSubTitle title={"예약 변경 규정"}/>
                <EditerBox addClass="minSize" data={reservationData?.exchange_information}/>
            </CustomPopup>

            <CustomPopup data={rentPopup} basicPB={addrPosition?.lat && addrPosition?.lng && isMobile() ? false : true} mSize={true}>
                <RentPopupContents
                    popup={rentPopup}
                    func={(addrData)=>{setAddrPosition(addrData)}}
                />
            </CustomPopup>
        </FixedSection>
    );
}

function FaqControll(data){
    const navigate = useNavigate();

    return (
        <FixedSection
            pageBox="pageSizing"
            boxAddClass={`fixedsection_min ${data.boxAddClass||""}`}
            addClass="fixedArea_min"
            contentsBox="fixedPage"
            headerChk={true}
            footerChk={true}
            minSize={961}
            title="자주 찾는 질문"
            titleAddClass={"pcItemT"}
        >
            <FilterSection addClass="flexBtnItemM">
                <FixedBox_btnItem
                    text={"자주 찾는 질문"}
                    icon={"/assets/images/icon/faq_icon.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/faq")
                    }}
                />
                <FixedBox_btnItem
                    text={"자차(면책)제도"}
                    icon={"/assets/images/icon/reservation_icon_2.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/insurance")
                    }}
                />
            </FilterSection>
        </FixedSection>
    );
}

export {BoardListBox,BoardListItem,BoardDetailPage,BoardDetailSection,CsControll,FaqControll}